import { FC, SVGProps } from 'react';

export const GemOutlined: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M16.5 7.5L9.72954 14.7218C9.33446 15.1432 8.66554 15.1432 8.27046 14.7218L1.5 7.5M16.5 7.5L13.2986 2.92654C13.1114 2.65921 12.8057 2.5 12.4793 2.5H10M16.5 7.5H11.5M1.5 7.5L4.70142 2.92654C4.88855 2.65921 5.19434 2.5 5.52066 2.5H7.75M1.5 7.5H6.5M10 2.5L11.5 7.5M10 2.5H7.75M11.5 7.5H6.5M7.75 2.5L6.5 7.5"
			stroke="currentColor"
			strokeWidth="1.4"
			strokeLinejoin="round"
		/>
	</svg>
);
